import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const KEY = "umagazin-intro-seen";

const Intro = () => {
  const [show, setShow] = useState(() => !sessionStorage.getItem(KEY));

  useEffect(() => {
    if (!show) return;
    const timer = setTimeout(() => {
      sessionStorage.setItem(KEY, "1");
      setShow(false);
    }, 1700);
    return () => clearTimeout(timer);
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="intro-overlay"
          className="fixed inset-0 z-[100] bg-bordeaux flex items-center justify-center"
          initial={{ y: 0 }}
          exit={{ y: "-100%" }}
          transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
          aria-hidden="true"
        >
          <motion.img
            src="/images/logo-white.png"
            alt=""
            className="w-[62vw] max-w-[420px] h-auto"
            initial={{ opacity: 0, scale: 0.96 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Intro;
